import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "25",
  fill: "none",
  viewBox: "0 0 26 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#pickem_svg__a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M21.25 0a4 4 0 0 1 4 4v17a4 4 0 0 1-4 4h-17a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm-8.688 10.28a2.036 2.036 0 1 0 .475 4.012l1.379 1.379v2.476c0 .281.111.551.31.75l2.918 2.917a1.063 1.063 0 0 0 1.813-.751v-1.854h1.854a1.063 1.063 0 0 0 .752-1.814l-2.918-2.916c-.199-.2-.469-.311-.75-.311h-2.477L14.54 12.79a2.036 2.036 0 0 0-1.978-2.51m4.257-6.81a9.815 9.815 0 0 0-13.93 7.193 9.81 9.81 0 0 0 10.762 11.398 1.063 1.063 0 0 0-.235-2.112 7.69 7.69 0 0 1-8.432-8.929 7.686 7.686 0 0 1 10.914-5.634 7.69 7.69 0 0 1 4.304 7.782 1.062 1.062 0 0 0 2.111.236 9.81 9.81 0 0 0-5.494-9.933m1.136 12.823.791.791h-.351c-.587 0-1.063.476-1.063 1.063v.351l-.791-.792v-1.413zm-3.127-9.45a5.925 5.925 0 0 0-8.076 4.315 5.925 5.925 0 0 0 5.81 7.08 1.063 1.063 0 0 0 0-2.126A3.8 3.8 0 0 1 9.875 9.63a3.8 3.8 0 0 1 6.485 2.686 1.063 1.063 0 0 0 2.125 0 5.92 5.92 0 0 0-3.657-5.472"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "pickem_svg__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M.25 0h25v25h-25z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }